import type { Event, EventHint } from "@sentry/types";

import patterns from "./agentInjectionPatterns.json";

const originalExceptionText = (originalException: EventHint["originalException"]): string => {
  if (originalException instanceof Error) return originalException.message;
  if (typeof originalException === "string") return originalException;

  return "";
};

// Scan the whole serialized event so injection text is caught in any field — the
// downstream LLM consumer reads the entire payload, not just the top-level message.
// The original exception is scanned separately since it is not part of the event.
const extractText = (event: Event, hint: EventHint): string =>
  [JSON.stringify(event), originalExceptionText(hint.originalException)].join("\n");

const agentInjection = (event: Event, hint: EventHint): Event | null => {
  const haystack = extractText(event, hint).toLowerCase();

  if (patterns.some(pattern => haystack.includes(pattern))) {
    return null;
  }

  return event;
};

export { agentInjection };
